export default "__VITE_ASSET__JchE09hC__"